<ng-container *ngIf="(convertedBookingFee$ | async) as convertedBookingFee">
    <span> {{ (calculateFees(rental, convertedBookingFee)) | currency: convertedBookingFee.currency : 'symbol-narrow' : '1.0-0' }}
    </span>
</ng-container>
